export const CHECKED_OUT = 'CHECKED_OUT'
export const CHECKED_IN = 'CHECKED_IN'
export const CLIENT_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
}
